export default __webpack_public_path__ + "static/media/FullscreenExit.62106f5c.svg";